import React from "react";
import { Box, Typography, Grid, List, ListItem,
  Paper, } from "@mui/material";
import { CheckCircle, Layers, Business } from "@mui/icons-material";
import HomeVideo from './HomeVideo';
import "./AboutUs.css";

const AboutUs = () => {
  const expertiseData = [
    "AI Generative Solutions",
    "Data Science",
    "Big Data Technologies",
    "Cybersecurity",
    "Cloud Computing",
    "AI/ML Ops & DevSecOps",
    "Observability & Performance Engineering",
    "Mobile Application Development (Andriod & Ios)",
    "Testing Center of Excellence (TCoE)",
  ];

  const industryData = [
    "CRM",
    "BFSI",
    "E-commerce",
    "Telecom",
    "Retail",
    "Automotive",
    "Aerospace",
    "Healthcare",
    "Travel and Logistics"
    
  ];
  return (
    <Box>
      <Box>
        <HomeVideo />
      </Box>
      <Box className="AboutUs">
        {/* Hero Section */}
        <Grid container className="section" spacing={4}>
          <Grid item xs={12} md={6} sx={{display:"flex",alignItems:"center", justifyContent:"center"}}>
            <Box
              component="img"
              src="/images/Technology-inspire-teamwork.png" // Replace with your image path
              alt="Our Story"
              sx={{
                width: "100%", // Ensure full width
                height: "265px", // Maintain aspect ratio
                borderRadius: "8px",
                boxShadow: 3,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6} className="hero-text">
            <Typography variant="h2">
              Who We Are
            </Typography>
            <Typography variant="body1">
                We are a software company focused on solving complex business problems with technology. Our problem-solving approach and product-thinking mindset enable us to create differentiated solutions at speed and scale, delivering enhanced outcomes for your business.With nearly two decades of expertise in the IT industry, we have had the privilege of working across diverse roles and domains, consistently engaging with cutting-edge technologies. Our journey spans:
            </Typography>
               {/* Expertise and Industries Horizontally */}
            <Paper
              elevation={4}
              sx={{
                borderRadius: "8px",
                overflow: "hidden",
                boxShadow: "0 8px 25px rgba(0, 0, 0, 0.15)",
              }}
            >
              <Grid container>
                {/* Expertise Section */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    backgroundColor: "#fff",
                    padding: "1.5rem",
                    borderRight: { xs: "none", sm: "1px solid #ddd" },
                    transition: 'transform 0.3s ease-in-out',
                      '&:hover': { transform: 'scale(1.05)' }
                  }}
                >
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.25rem",
                      color: "#333",
                      marginBottom: "1rem",
                    }}
                  >
                    <CheckCircle
                      sx={{
                        fontSize: "1.5rem",
                        color: "#4caf50",
                        verticalAlign: "middle",
                        marginRight: "0.5rem",
                      }}
                    />
                    Expertise
                  </Typography>
                  <List disablePadding>
                    {expertiseData.map((item, index) => (
                      <ListItem
                        key={index}
                        sx={{
                          padding: "0.5rem 0",
                          color: "#555",
                          fontSize: "0.95rem",
                        }}
                      >
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Grid>

                {/* Industries Section */}
                <Grid
                  item
                  xs={12}
                  sm={6}
                  sx={{
                    backgroundColor: "#fff",
                    padding: "1.5rem",
                    transition: 'transform 0.3s ease-in-out',
                      '&:hover': { transform: 'scale(1.05)' },
                  }}
                >
                  <Typography
                    variant="h5"
                    gutterBottom
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1.25rem",
                      color: "#333",
                      marginBottom: "1rem",
                    }}
                  >
                    <Business
                      sx={{
                        fontSize: "1.5rem",
                        color: "#2196f3",
                        verticalAlign: "middle",
                        marginRight: "0.5rem",
                      }}
                    />
                    Industries
                  </Typography>
                  <List disablePadding>
                    {industryData.map((item, index) => (
                      <ListItem
                        key={index}
                        sx={{
                          padding: "0.5rem 0",
                          color: "#555",
                          fontSize: "0.95rem",
                        }}
                      >
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>

        {/* Our Values Section */}
        <Grid container className="section" spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4">Our Values</Typography>
            <Typography variant="body1">
              We believe in integrity, collaboration, and innovation. Our team is committed to creating
              solutions that drive success while fostering an inclusive and supportive environment for
              growth and creativity.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/images/our-values.avif" // Replace with image path for Values
              alt="Our Values"
              sx={{
                width: "100%", // Full width
                height: "265px", // Fixed height for consistency
                borderRadius: "8px",
                boxShadow: 3,
              }}
            />
          </Grid>
        </Grid>

        {/* Our Vision Section */}
        <Grid container className="section" spacing={4}>
          <Grid item xs={12} md={6}>
            <Typography variant="h4">Our Vision</Typography>
            <Typography variant="body1">
              Our vision is to empower businesses with cutting-edge technology solutions, driving
              innovation and creating value at every step. We aim to be a trusted partner, offering
              exceptional products and services that address the most complex business challenges.
            </Typography>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/images/vision.jpg" // Replace with image path for Vision
              alt="Our Vision"
              sx={{
                width: "100%", // Full width
                height: "265px", // Fixed height
                borderRadius: "8px",
                boxShadow: 3,
              }}
            />
          </Grid>
        </Grid>

        {/* Our Mission Section */}
        <Grid container className="section" spacing={4}>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/images/mission.avif" // Replace with image path for Mission
              alt="Our Mission"
              sx={{
                width: "100%", // Full width
                height: "265px", // Fixed height
                borderRadius: "8px",
                boxShadow: 3,
              }}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="h4">Our Mission</Typography>
            <Typography variant="body1">
              Our mission is to deliver high-quality software solutions that help our clients
              navigate their most pressing challenges. We strive to provide innovative tools,
              exceptional service, and scalable solutions that make a difference in the world.
            </Typography>
          </Grid>
        </Grid>

        {/* Call-to-Action Section */}
        {/* <Grid container className="cta" spacing={4}>
        <Grid item xs={12} md={6}>
          <Typography variant="h5">
            Ready to innovate with us?
          </Typography>
          <Button variant="contained" size="large">
            Get in Touch
          </Button>
        </Grid>
      </Grid> */}
      </Box>
    </Box>
  );
};

export default AboutUs;
